module.exports = __webpack_public_path__ + "media/images/contact-receive-payments-cbbe1acb030406cbd0e286bed71a80f5.png";